import { CheckoutButton } from "@/components/CheckoutButton";
import { PRECIO_MENSUAL } from "@/config";

export const StickyCta = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 border-t border-[#22304D] bg-[#0B1120]/92 p-3 backdrop-blur-md md:hidden">
    <CheckoutButton
      testId="sticky-join-button"
      origen="sticky"
      className="w-full !py-3.5 !text-base"
    >
      Unirme por {PRECIO_MENSUAL} €/mes
    </CheckoutButton>
  </div>
);
